import useAsync from 'react-use/lib/useAsync';
import { useApi } from '@backstage/core-plugin-api';
import { mlflowApiRef } from '../../../api/MLFlowApi';
import { transformDevicesToOptions } from '../../../utils/transforms';

export const useMLFlowData = (entity: any) => {
  const mlflowApi = useApi(mlflowApiRef);

  return useAsync(async () => {
    const modelName = entity?.spec?.modelInfo?.modelName;
    
    if (!modelName) {
      throw new Error('Model name not found in entity specification');
    }
    
    const [devicesData, modelData, modelVersions] = await Promise.all([
      mlflowApi.getDevices(),
      mlflowApi.getRegisteredModel(modelName),
      mlflowApi.getModelVersions(modelName),
    ]);

    const devices = transformDevicesToOptions(devicesData);

    return {
      mlFlowModelDetail: {
        model: modelData.registered_model,
        runInfo: modelData.runInfo,
        versions: modelVersions,
        devices,
      },
    };
  }, [mlflowApi, entity]);
};
